

const DEBUG_MODE = false

const debuglog= (...x) =>{
if (DEBUG_MODE)  console.log(...x)

}

export default debuglog;